export default __webpack_public_path__ + "static/media/logo.d2d015ef.png";